import {HttpCrudDataSource} from '../../../core/data-source/http-crud.data-source';

export class FuelTypeCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/fp';
}
